import {Component, OnInit} from '@angular/core';
import {ServicioCaptacionService} from '../../services/servicio-captacion.service';
import {ActivatedRoute} from '@angular/router';
import {ExcelService} from '../../services/utils/excel.service';
import {EntidadEmpresarialEntity, ServicioEntidadService} from '../../services/servicio-entidad.service';
import {HttpErrorResponse} from '@angular/common/http';
import {CarteraPacienteEntity, ServicioCarteraPacienteService} from '../../services/servicio-cartera-paciente.service';
import { ImagesService } from 'src/app/services/utils/images.service';

@Component({
  selector: 'app-reporte-cartera-pacientes',
  templateUrl: './reporte-cartera-pacientes.component.html',
  styleUrls: ['./reporte-cartera-pacientes.component.css']
})
export class ReporteCarteraPacientesComponent implements OnInit {

  carterasPacientes: CarteraPacienteEntity[][] = [];

  entidadEmpresarial: EntidadEmpresarialEntity = new class implements EntidadEmpresarialEntity {
    codigoPrestador: string;
    descripcion: string;
    digitoVerificacion: string;
    direccion: string;
    identificacionTributaria: string;
    sede: string;
    telefono: string;
    unco: number;
    urlLogo: string;
  };

  uncoSede: number;

  loading: boolean;

  codeBd: string;
  logo: string;
  user: string;

  fechaImpresion: Date;
  now = new Date();

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioCaptacionService: ServicioCaptacionService,
    private servicioCarteraPacienteService: ServicioCarteraPacienteService,
    private servicioImagenes: ImagesService,
    private servicioEntidad: ServicioEntidadService,
    private servicioExcel: ExcelService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.codeBd = params['codigoBaseDatos'];
      this.uncoSede = params['uncoSede'];
      this.user = params['user'];
    });
  }

  async ngOnInit() {
    this.getLogo(this.codeBd);
    this.now = new Date();
  }

  async onFiltrosCompletados($event: any) {
    this.loading = true;
    this.now = new Date();
    this.getLogo(this.codeBd);
    this.getData($event)
  }

  async getLogo(codigoBaseDatos: string) {
    try {
      this.logo = '';
      const response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: any) => {
          this.logo = data.source;
          this.getEntidadEmpresarial();
        }, (err: HttpErrorResponse) => {
          this.logo = '';
          console.error('Error ReporteCaptacion.getLogo():', err);
        })
      }
    } catch(e) {
      this.logo = '';
      console.error('Catch ReporteCaptacion.getLogo():', e);
    }
  }

  async getEntidadEmpresarial() {
    const response = await this.servicioEntidad.getEntidadEmpresarial(this.codeBd, this.uncoSede);
    if (response != null) {
      response.subscribe((data: any) => {
        if (data && Array.isArray(data) && data.length > 0) {
          this.entidadEmpresarial = data[0];
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error entidad Empresarial', err);
      });
    }
  }

  async getData(event: any) {
    const response = await this.servicioCarteraPacienteService.getCarteraPaciente(this.codeBd, event.fechaInicial, event.fechaFinal);

    if (response != null) {
      response.subscribe((carterasPaciente: CarteraPacienteEntity[]) => {
        const carterasPacientesGroupByCaptador = {};
        this.carterasPacientes.length = 0;

        for (const carteraPaciente of carterasPaciente) {
          const key: string = carteraPaciente.captador;
          if (!Object.keys(carterasPacientesGroupByCaptador).includes(key)) {
            carterasPacientesGroupByCaptador[key] = [];
          }
          carterasPacientesGroupByCaptador[key].push(carteraPaciente);
        }

        for (const captacionesGroupByCaptadorKey of Object.keys(carterasPacientesGroupByCaptador)) {
          this.carterasPacientes.push(carterasPacientesGroupByCaptador[captacionesGroupByCaptadorKey]);
        }
        this.loading = false;
      }, (err: any) => {
        console.error('Catch ReporteCarteraPacientes.onFiltrosCompletados(): ', err);
        this.loading = false;
      });
    }
  }

  buildExcel() {

    const carterasPacientes = [];

    for (const carteraPaciente of this.carterasPacientes) {
      for (const tmp of carteraPaciente) {
        carterasPacientes.push(tmp);
      }
    }

    const newCarterasPacientes = carterasPacientes.map(item => {
      return {
        captador : item.captador,
        fechaCita : item.fechaCita,
        identificacion : item.identificacionPaciente,
        paciente : item.paciente,
        asistio : item.asistio,
        valorPago : item.valorPago,
        valorPagado : item.valorPagado,
        saldo : item.saldo
      };
    });

    this.servicioExcel.exportAsExcelFile(newCarterasPacientes, 'reporte cartera paciente', 'reporte cartera paciente');
  }

  onSumarValorServicio(carterasPacienteEntity: CarteraPacienteEntity[]) {
    let valorPago = 0;
    for (const carteraPacienteEntity of carterasPacienteEntity) {
      valorPago = valorPago + carteraPacienteEntity.valorPago;
    }
    return valorPago;
  }

  onSumarValorRecaudado(carterasPacienteEntity: CarteraPacienteEntity[]) {
    let valorPagado = 0;
    for (const carteraPacienteEntity of carterasPacienteEntity) {
      valorPagado = valorPagado + carteraPacienteEntity.valorPagado;
    }
    return valorPagado;
  }

  onSumarSaldo(carterasPacienteEntity: CarteraPacienteEntity[]) {
    let saldo = 0;
    for (const carteraPacienteEntity of carterasPacienteEntity) {
      saldo = saldo + carteraPacienteEntity.saldo;
    }
    return saldo;
  }
}
